import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router, UrlTree } from '@angular/router';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Location } from '@angular/common';
import { NotificationService } from '../../services/notification.service';
import { Notification } from '../../models/notification.model';
import { ApplicationWorkflowService } from '../../../application/services/application-workflow.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-notification-view',
    templateUrl: './notification-view.component.html',
    styleUrl: './notification-view.component.scss',
    standalone: false
})
export class NotificationViewComponent implements OnInit, OnDestroy {

  id: number = 0;
  //@ts-ignore
  bodyText: SafeHtml;

  //@ts-ignore
  item: Notification;
  applicationId: number | null = null;
  companyId: number | null = null;
  isLoading: boolean = false;

  subs: Subscription[] = [];
  constructor(private router: Router, private route: ActivatedRoute, private notificationService: NotificationService,
    private sanitizer: DomSanitizer, private location: Location, private workflowService: ApplicationWorkflowService
  ) {

  }

  ngOnInit(): void {
    this.mapItem();
    this.subs.push(
      this.notificationService.showNotificationContent$.subscribe(resp => {
        this.mapItem();
      })
    );
  }

  ngOnDestroy(): void {
    this.subs.forEach(s => s.unsubscribe());
  }

  private mapItem() {
    this.item = this.notificationService.selectedItem;
    if (this.item) {
      if (!this.item.seen) {
        this.notificationService.setIsRead(this.item.id).subscribe(resp => {
        });
      }
      this.bodyText = this.sanitizer.bypassSecurityTrustHtml(this.item.messageBody.replace(/\/n/g, '<br>'));
      if (this.item.additionalInfo != null && this.item.additionalInfo) {
        var appID = (this.item.additionalInfo as any)['applicationId'];
        if (appID != null) {
          this.applicationId = Number(appID);
        }
        var companyId = (this.item.additionalInfo as any)['companyId'];
        if (companyId != null) {
          this.companyId = Number(companyId);
        }
        // var appId = this.item.additionalInfo.find(map => map.has('applicationId'))
        //       ?.get('applicationId') || null;
        // if (appId != null) {
        //   this.applicationId = Number(appId);
        // }
      }
    }
    else if (!this.item) {
      this.router.navigate(['/portal']);
    }
  }

  public onBack() {
    this.notificationService.showNotificationModal$.next(1);
  }

  public isShowCompanyBtn(): boolean {
    return this.companyId != null;
  }

  public isShowApplicationBtn(): boolean {
    return this.applicationId != null;
  }


  goToApplication() {
    if (this.applicationId != null) {
      this.isLoading = true;
      this.workflowService.getActualAppId(this.applicationId).subscribe(actualId => {
        this.isLoading = false;
        if (actualId != null && actualId != undefined) {
          let url: UrlTree;
          url = this.router.createUrlTree(
            ['/applications/registration/edit', actualId]
          );
          window.open(this.router.serializeUrl(url), '_blank');
        }
        else {
          alert('Current Application Id is not found. Check console for more details.');
          console.error('Current Application Id is not found in additionalInfo map.');
        }
      });
    }
    else {
      alert('Application Id is not found. Check console for more details.');
      console.error('Application Id is not found in additionalInfo map.');
    }
  }
}


